import gql from 'graphql-tag';
import collegeEventFilterFragment from '../../CollegeEventsEditEvent/graphql/collegeEventFilterFragment';

export default gql`
  mutation deleteCollegeEventFilter($input: deleteCollegeEventFilterInput!) {
    deleteCollegeEventFilter(input: $input) {
      viewer {
        id
        eventFilters {
          ...CollegeEventFilter
          version
          publishedCollegeEventCount
          expiredCollegeEventCount
          unpublishedCollegeEventCount
          filterMatches
        }
      }
    }
  }
  ${collegeEventFilterFragment}
`;
